import {Location} from "@components/Booking/LocationSelection/types";
import {useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";
import React from "react";
import {withTextStyle} from "@components/Booking/LocationSelection/LocationRow/styles";

const HoursOfOperation = ({disabled, location}: {disabled: boolean; location: Location}) => {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  const className = withTextStyle("", "text-gray-900", disabled);
  if (location?.isOpen) {
    const time =
      location?.closesTodayAt?.minuteOfHour === "0"
        ? location?.closesTodayAt?.timeHourOnly?.toLowerCase()
        : location?.closesTodayAt?.timeHourMinute?.toLowerCase();
    return <span className={className}>{i18n.t("Open until {{time}}", {time})}</span>;
  }

  const time =
    location?.opensNextAt?.minuteOfHour === "0"
      ? location?.opensNextAt?.timeHourOnly?.toLowerCase()
      : location?.opensNextAt?.timeHourMinute?.toLowerCase();

  if (location?.opensNextAt?.daysFromNow === 0) {
    return <span className={className}>{i18n.t("Opens at {{time}}", {time})}</span>;
  } else if (location?.opensNextAt?.daysFromNow === 1) {
    return <span className={className}>{i18n.t("Opens {{time}} tomorrow", {time})}</span>;
  } else if (location?.opensNextAt?.daysFromNow ?? 8 < 7) {
    const day = location?.opensNextAt?.dayOfWeek;
    return <span className={className}>{i18n.t("Opens {{day}} at {{time}}", {day, time})}</span>;
  } else {
    const date = location?.opensNextAt?.date;
    return <span className={className}>{i18n.t("Opens {{date}} at {{time}}", {date, time})}</span>;
  }
};

export default React.memo(HoursOfOperation);
